import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "monaco-container" }
const _hoisted_3 = { class: "monaco-container" }
const _hoisted_4 = { class: "schema-create-ft" }

import { ref, computed, watch } from 'vue'
import FormItemLabel from '@/components/FormItemLabel.vue'
import Monaco from '@/components/Monaco.vue'
import useI18nTl from '@/hooks/useI18nTl'
import { setConfig, getConfig } from '@/api/evses'
import { ElMessageBox, ElMessage } from 'element-plus'
import { checkMenuShow } from '@/store/tool'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseConfig',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  evse: {
    type: Object,
    default: () => {},
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')

const evseConfigLock = ref(false)
const currTab = ref('setconfig')
const record = ref<Record<string, any>>({
  params: '',
})



const submit = async () => {
  record.value.evseID = props.evse?.id
  if (record.value.evseID == '' || record.value.evseID == '0') {
    ElMessage.error(t('Error.errInvalidArgument'))
    return
  }

  console.log(currTab, record.value)
  try {
    if (currTab.value == 'setconfig') {
      record.value.params = record.value.setConfig
      await setConfig(record.value)
    } else if (currTab.value == 'getconfig') {
      record.value.params = record.value.getConfig
      const { kvs } = await getConfig(record.value)
      record.value.getConfig = ''
      for (const kv of kvs) {
        record.value.getConfig += `${kv['k']}: ${kv['v']}\n`
      }
    }
    ElMessage.success(t('Base.opSuccess'))
  } catch (error) {
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "app-card schema-create-card" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
        class: "config-tabs",
        modelValue: currTab.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currTab).value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
              label: _ctx.$t('Evses.setConfig'),
              name: "setconfig",
              lazy: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "setconfig",
                  prop: "record"
                }, {
                  label: _withCtx(() => [
                    _createVNode(FormItemLabel, {
                      label: _ctx.$t('Evses.setConfig'),
                      desc: _ctx.$t('Evses.setConfigDesc'),
                      "popper-class": "is-wider"
                    }, null, 8, ["label", "desc"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(Monaco, {
                        modelValue: record.value.setConfig,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.setConfig) = $event)),
                        id: "setConfig",
                        lang: "yaml"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"])), [
              [_directive_role, 'evseConfigSet']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
              label: _ctx.$t('Evses.getConfig'),
              name: "getconfig",
              lazy: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "getconfig",
                  prop: "record"
                }, {
                  label: _withCtx(() => [
                    _createVNode(FormItemLabel, {
                      label: _ctx.$t('Evses.getConfig'),
                      desc: _ctx.$t('Evses.getConfigDesc'),
                      "popper-class": "is-wider"
                    }, null, 8, ["label", "desc"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(Monaco, {
                        modelValue: record.value.getConfig,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.getConfig) = $event)),
                        id: "getConfig",
                        lang: "yaml"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"])), [
              [_directive_role, 'evseConfigGet']
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])), [
        [
          _directive_loading,
          evseConfigLock.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 2 }),
          _createVNode(_component_el_col, { span: 22 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  disabled: !_ctx.$hasPermission('post'),
                  onClick: submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.apply')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})